import { CircleAlert } from "lucide-react";

const reviewStats = [
  {
    label: "All applicants",
    value: 59,
  },
  {
    label: "Priority applicants",
    value: 18,
  },
  {
    label: "Below threshold",
    value: 41,
  },
  {
    label: "Preferred minimum",
    value: 20,
  },
];

const ApplicationManagementRightPanel = () => {
  return (
    <div className="flex flex-col w-[25%] gap-3">
      {/* Section 1 */}
      <div className="flex flex-col rounded-md bg-white border h-max overflow-hidden px-4 py-5 gap-1.5">
        <span className="uppercase text-xss tracking-wider font-bold text-light-black">
          review threshold
        </span>
        <span className="font-semibold text-3xl">75%</span>
        <span className="text-xss font-medium text-light-black">
          Scores of 75% or higher
        </span>

        <div className="rounded-md flex flex-col border mb-2">
          {reviewStats?.map((stat) => {
            return (
              <div className="flex items-center justify-between border-b py-2 px-2">
                <span className="text-xss font-medium text-light-black">
                  {stat?.label}
                </span>
                <span className="text-xss font-bold">{stat?.value}</span>
              </div>
            );
          })}
          <div className="flex items-center py-2 px-2 gap-1">
            <CircleAlert fill="red" color="white" size={17} />
            <span className="text-xsss font-bold text-orange-700">
              2 below preferred review volume
            </span>
          </div>
        </div>

        <button className="flex items-center justify-center rounded-md bg-slate-600 py-2.5 w-full text-xss text-white font-bold hover:bg-slate-600/90">
          Preview new threshold
        </button>
        <button className="flex items-center justify-center py-1 w-full text-content-muted font-bold text-xss hover:bg-gray-50 rounded-md">
          Manage preference
        </button>
      </div>

      {/* Section 2 */}
      <div className="flex flex-col rounded-md bg-white border h-max overflow-hidden px-4 py-3 gap-1.5">
        <span className="uppercase text-xss tracking-wider font-bold text-light-black">
          queue health
        </span>

        <div className="flex items-center gap-2">
          <div className="rounded-full h-2 w-2 bg-green-600" />
          <span className="font-semibold text-xss">
            18 candidates ready to review
          </span>
        </div>

        <div className="flex items-center gap-1 text-light-black font-medium text-xss">
          <div className="flex items-center">12 new</div>·
          <div className="flex items-center">4 reviewing</div>·
          <div className="flex items-center">2 reviewed</div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationManagementRightPanel;
